// extracted by mini-css-extract-plugin
export const container = "projects-module--container--3DCbt";
export const projectCard = "projects-module--projectCard--1Gzh9";
export const projectCardIamge = "projects-module--projectCardIamge--3BIVA";
export const projectCardBody = "projects-module--projectCardBody--3J66x";